/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { object, Schema, string } from '../schema';

export interface MerchantDetails {
  merchantName: string;
  merchantCategoryCode: string;
}

export const merchantDetailsSchema: Schema<MerchantDetails> = object({
  merchantName: ['MerchantName', string()],
  merchantCategoryCode: ['MerchantCategoryCode', string()],
});
